import { render, staticRenderFns } from "./PvDrawerArticleStatsRow.vue?vue&type=template&id=35a4d93a&scoped=true&"
import script from "./PvDrawerArticleStatsRow.vue?vue&type=script&lang=js&"
export * from "./PvDrawerArticleStatsRow.vue?vue&type=script&lang=js&"
import style0 from "./PvDrawerArticleStatsRow.vue?vue&type=style&index=0&id=35a4d93a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a4d93a",
  null
  
)

export default component.exports